import type { PermissionEngine, PermissionAction } from '@/mocks/saRolesPermissions';

export const ENGINE_ICONS: Record<PermissionEngine, string> = {
  platform: 'ri-cpu-line',
  identity: 'ri-fingerprint-line',
  radio: 'ri-radio-line',
  community: 'ri-group-line',
  content: 'ri-file-list-3-line',
  interaction: 'ri-chat-3-line',
  notification: 'ri-notification-3-line',
  discovery: 'ri-compass-3-line',
  commerce: 'ri-shopping-cart-2-line',
  advertising: 'ri-megaphone-line',
  analytics: 'ri-bar-chart-2-line',
  ai: 'ri-robot-2-line',
};

export const ACTION_ICONS: Record<PermissionAction, string> = {
  view: 'ri-eye-line',
  create: 'ri-add-circle-line',
  edit: 'ri-edit-line',
  delete: 'ri-delete-bin-line',
  approve: 'ri-check-double-line',
  reject: 'ri-close-circle-line',
  export: 'ri-download-2-line',
  manage: 'ri-settings-4-line',
  impersonate: 'ri-user-shared-line',
  moderate: 'ri-shield-check-line',
  publish: 'ri-send-plane-line',
  configure: 'ri-tools-line',
};

export const ACTION_COLORS: Record<PermissionAction, string> = {
  view: '#059669',
  create: '#2563eb',
  edit: '#ca8a04',
  delete: '#dc2626',
  approve: '#16a34a',
  reject: '#dc2626',
  export: '#7c3aed',
  manage: '#0f172a',
  impersonate: '#e11d48',
  moderate: '#ea580c',
  publish: '#0891b2',
  configure: '#4f46e5',
};

export const HIERARCHY_LABELS: Record<number, string> = {
  1: 'Nivel 1 — Sistema',
  2: 'Nivel 2 — Plataforma',
  3: 'Nivel 3 — Operaciones',
  4: 'Nivel 4 — Propietario',
  5: 'Nivel 5 — Administración',
  6: 'Nivel 6 — Staff',
  7: 'Nivel 7 — Creador',
  8: 'Nivel 8 — Usuario',
};